import { Alert, PageHeader, Skeleton } from '@catering/ui';
import { SlidersHorizontal } from 'lucide-react';
import type { JSX } from 'react';

import { hasPermission } from '../../../auth/has-permission';
import { useCurrentUser } from '../../../auth/use-current-user';
import { SettingsForm } from './components/SettingsForm';

/**
 * `settings-hub/spec.md`, "Parámetros del Sistema distingue vista de
 * edición": reachable with `settings.read` (read-only) or `settings.manage`
 * (editable). Reached from the `/settings` hub card, but also double-checks
 * the permission itself — same reasoning as `ArcaConfigPage` — because
 * `GET /settings` requires `settings.read` on every route.
 */
export function SystemParametersPage(): JSX.Element {
  const currentUser = useCurrentUser();
  const canRead = hasPermission(currentUser.data, 'settings.read');
  const canManage = hasPermission(currentUser.data, 'settings.manage');
  const canViewHistory = hasPermission(currentUser.data, 'audit.read');

  if (currentUser.isPending) {
    return <Skeleton className="h-40 w-full" />;
  }

  if (!canRead) {
    return (
      <Alert tone="danger" title="Sección restringida">
        No tenés permiso para acceder a los parámetros del sistema.
      </Alert>
    );
  }

  return (
    <section className="flex flex-col gap-6">
      <PageHeader
        icon={SlidersHorizontal}
        title="Parámetros del sistema"
        description="Configurá el cierre de pedidos y otros parámetros operativos."
      />

      <SettingsForm canManage={canManage} canViewHistory={canViewHistory} />
    </section>
  );
}
